module.exports = __webpack_public_path__ + "static/media/pms111.edf68ce5.jpg";